import type {
  TimeRestrictionItemEmpty,
  TimeRestrictionItemStrict,
  TimeRestrictionsStrict,
} from 'app/dataTypes/OrgSettingsTimeRestrictions.types'

import * as dm from 'app/dataTypes/dayModes'

const defaultRestrictions: TimeRestrictionsStrict = [
  [
    {
      time: '08:00',
      dayMode: dm.BEFORE,
      wday: null,
    },
    {
      time: '11:00',
      dayMode: dm.BEFORE,
      wday: null,
    },
    {
      time: '13:00',
      dayMode: dm.BEFORE,
      wday: null,
    },
  ],
  [
    {
      // 2-я смена
      time: '12:00',
      dayMode: dm.BEFORE,
      wday: null,
    },
    {
      time: '15:00',
      dayMode: dm.BEFORE,
      wday: null,
    },
    {
      time: '17:00',
      dayMode: dm.BEFORE,
      wday: null,
    },
  ],
  [
    {
      // 3-я смена
      time: '12:00',
      dayMode: dm.BEFORE,
      wday: null,
    },
    {
      time: '12:00',
      dayMode: dm.BEFORE,
      wday: null,
    },
    {
      time: '12:00',
      dayMode: dm.BEFORE,
      wday: null,
    },
  ],
]

export const setNullsToDefault = (
  groups: Array<Array<TimeRestrictionItemEmpty | TimeRestrictionItemStrict>>,
): TimeRestrictionsStrict =>
  groups.map((foodModes, gIndex) =>
    foodModes.map(({ time, dayMode, wday }, fIndex): TimeRestrictionItemStrict => {
      if (time && (dayMode === dm.BEFORE || dayMode === dm.TODAY)) {
        return { time, dayMode, wday }
      }
      if (time && dayMode === dm.NEXT_WEEK && typeof wday === 'number') {
        return { time, dayMode, wday }
      }
      return defaultRestrictions[gIndex][fIndex]
    }),
  )
